var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"button",class:[_vm.color, { visible: _vm.visible, disabled: _vm.disabled, loading: _vm.loading }],on:{"click":function($event){return _vm.$emit('click', $event)}}},[(!_vm.loading)?_vm._t("default"):_c('uiLoader')],2)
}
var staticRenderFns = []

export { render, staticRenderFns }